import { ShapeTool } from ".";
import { Vector2 } from "../utils/vector2";

const fabric = require("../fabric").fabric;

export class LineTool extends ShapeTool {

  mesurementText = null;
  measurementActive = false;

  buildShape(pointer, origX, origY) {
    let styleModule = this.imageEditor.getModule("style");

    this.measurementActive = false;
    if(this.imageEditor.isToolbarToggleActive("mesures-toggle")) {
      this.measurementActive = true;
      this.mesurementText = this.getNewMesurementText(origX, origY);
      this.mesurementText.text = ``;
      this.imageEditor.canvas.add(this.mesurementText);
    }

    return new fabric.Line([pointer.x, pointer.y, pointer.x, pointer.y], {
      fill: styleModule.fillColor,
      stroke: styleModule.fillColor,
      strokeWidth: styleModule.strokeSize,
      transparentCorners: false,
      selectable: false
    });
  }

  mouseDrag(line, pointer, origX, origY) {
    line.set({x2:pointer.x,y2:pointer.y});

    if(this.measurementActive) {
      var from = new Vector2(line.x1, line.y1);
      var to = new Vector2(line.x2, line.y2);

      var pixelLength = from.distanceTo(to);
      var distance = this.imageEditor.calculateMesurementValue(pixelLength);
      distance = Math.round(distance * 100) / 100;
      var middle = from.middle(to);

      var angle = from.getAngle(to);
      var deg = angle * 180 / Math.PI;
      var yOff = deg > 0 ? 50 : -50;
      var vOffset = new Vector2(yOff, this.mesurementText.width / 2 * (deg > 0 ? 1 : -1)).rotate(angle);

      var labelPos = middle.add(vOffset);

      let mesurement = this.mesurementText;
      mesurement.text = `${distance}${this.imageEditor.mesurementUnit}`;
      mesurement.fontSize = line.strokeWidth * 5;
      mesurement.left = labelPos.x;
      mesurement.top = labelPos.y;
      mesurement.angle = deg > 0 ? deg - 90 : deg + 90;
      mesurement.drawObject(this.imageEditor.canvas.getContext());
    }
  }

  shapePlaced(line) {
    this.imageEditor.canvas.renderAll();
  }

}